import { useState } from 'react'
import { Webhook, ChevronDown, ChevronUp } from 'lucide-react'
import { DeliveryRow, statusPresentation } from './ActionActivity.js'

/**
 * Per-step Action activity — a collapsible section at the bottom of a step card
 * showing the outbound webhook deliveries fired by that step's completion.
 * Renders nothing when the step has no deliveries. Deliveries are supplied by
 * the page (fetched/polled once for the whole instance) and grouped by step.
 */
export default function StepActionActivity({ deliveries = [], onRetry }) {
  const [open, setOpen] = useState(false);

  if (!deliveries.length) return null;

  const latest = deliveries[0]; // endpoint returns newest first
  const { label, cls } = statusPresentation(latest);

  return (
    <div className="px-5 pb-4 border-t border-gray-100 dark:border-zinc-700 pt-3">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="flex items-center justify-between w-full group"
      >
        <span className="flex items-center gap-2 text-xs font-medium text-gray-600 dark:text-gray-300">
          <Webhook className="h-3.5 w-3.5 text-sky-600 dark:text-sky-400" />
          Action activity
          <span className="text-gray-400">({deliveries.length})</span>
        </span>
        <span className="flex items-center gap-2">
          <span className={`inline-flex items-center rounded-md px-1.5 py-0.5 text-[11px] font-medium ring-1 ring-inset ${cls}`}>{label}</span>
          {open
            ? <ChevronUp className="h-3.5 w-3.5 text-gray-400" />
            : <ChevronDown className="h-3.5 w-3.5 text-gray-400" />}
        </span>
      </button>

      {open && (
        <div className="mt-2 space-y-1.5">
          {deliveries.map((d) => <DeliveryRow key={d.id} delivery={d} onRetry={onRetry} />)}
        </div>
      )}
    </div>
  )
}
